import { extractApiErrorMessage } from "../../../../utils/util";
import DSAlert from "../../../system-design/DSAlert";
import DSCard from "../../../system-design/DSCard";
import DSCardContent from "../../../system-design/DSCardContent";
import DSFormControlLabel from "../../../system-design/DSFormControlLabel";
import DSHint from "../../../system-design/DSHint";
import DSSwitch from "../../../system-design/DSSwitch";
import {
  useMomentSettingsQuery,
  useSetKlydoSelectionMutation,
} from "../hooks/useMomentSettings";

// How the klydo of a moment is chosen. One switch for the whole tab.
const MomentKlydoSelection = () => {
  const { data: settings, error: loadError } = useMomentSettingsQuery();
  const {
    mutate: setSelection,
    isPending,
    error: saveError,
  } = useSetKlydoSelectionMutation();
  const error = loadError ?? saveError;

  return (
    <DSCard sx={{ mb: 3 }}>
      <DSCardContent>
        <DSHint label="Klydo choice">
          How the klydo of a moment is chosen.
          <ul style={{ margin: "8px 0 0", paddingLeft: 20 }}>
            <li>
              <b>Off (random):</b> a random klydo from the occasion&apos;s own
              list, chosen the moment the user saves.
            </li>
            <li>
              <b>On (semantic search):</b> the moment is saved at once with a
              klydo from the occasion&apos;s list, and a few seconds later it is
              replaced by a klydo found by searching for the occasion&apos;s
              search phrase. If the search finds nothing new, the klydo from the
              list stays.
            </li>
            <li>
              Yearly moments choose a new klydo the clock does not have yet on
              every repeat, by the setting at that time. Moments of any kind
              keep the picture generated for them.
            </li>
          </ul>
        </DSHint>
        {error && (
          <DSAlert severity="error" sx={{ mt: 1 }}>
            {extractApiErrorMessage(error, "Failed to save the klydo choice")}
          </DSAlert>
        )}
        <DSFormControlLabel
          control={
            <DSSwitch
              checked={settings?.klydoSelection === "semantic"}
              disabled={!settings || isPending}
              onChange={(e) =>
                setSelection(e.target.checked ? "semantic" : "random")
              }
            />
          }
          label="Semantic search for klydos"
        />
      </DSCardContent>
    </DSCard>
  );
};

export default MomentKlydoSelection;
